import React, {useState, useEffect} from "react"
import { Component } from "react";
import { Link } from "react-router-dom";

import HomeHTMLLogo from "../img/Frontend/HomeHTML.jpg";
import HomeBackLogo from  "../img/Backend/HomeBackLogo.jpg"

import Header from "./Header";
import BurgerMenu from "./BurgerMenu"

import "../styles/Materias.css";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Cookies from "universal-cookie"
import Swal from "sweetalert";
import PropTypes from "prop-types"

import { setTranslations, setDefaultLanguage, setLanguageCookie, setLanguage, translate, getLanguage} from 'react-switch-lang';
import en from "../langs/eng.json";
import sp from "../langs/esp.json";

const warnIcon = "https://cdn-icons-png.flaticon.com/512/595/595067.png";
const stopIcon = "https://cdn-icons-png.flaticon.com/512/3061/3061695.png";
const workerIcon = "https://cdn-icons-png.flaticon.com/512/1018/1018662.png";

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1365 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1365, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


setTranslations({en,sp});
setDefaultLanguage('en')

class Materias extends Component{

    handleSetLanguage = (key) =>{
        setLanguage(key);
    }

    handleClickNotPrepared = () =>{
        const {t} = this.props;
        Swal(t("notAvailable.notYet.back"));
    }

    handleClickUnderConstruction = () =>{
        const {t} = this.props;
        Swal(t("notAvailable.workInProgress"));
    }

    componentDidMount(){
        const cookieVisited = new Cookies('visited');
        const cookieLanguage = new Cookies('language');

        const {t} = this.props;

        if(!cookieVisited.get('visited')){

            const current = new Date();
            const nextYear = new Date();
            nextYear.setFullYear(current.getFullYear() + 1);

            cookieVisited.set('visited',true,
            {path:'/My-Portfolio',
            expires: nextYear,
        });

            Swal({
                title: t('firstTime.title'),
                text: t('firstTime.msg'),
                icon: "success",
                buttons: {
                    sp: {
                        text: "Español",
                        value: "sp"
                    },
                    en: {
                        text: "English",
                        value: "en"
                    }
                }

            })
            .then((value)=>{

                this.handleSetLanguage(value);
                cookieLanguage.set('language', value, 
                {path: '/My-Portfolio',
                expires: nextYear,
            
            })
            }); 
            
        }
    }

    render(){

        const cookieLanguage = new Cookies('language');

        const {t} = this.props;

        return(
            <div className="homeMaterias">
                
                <Header urlBack="" showIcons={false}/>

                <BurgerMenu/>

                <Carousel responsive={responsive} containerClass="carouselMaterias">
                    
                    <div className="materia">
                        <Link to="/My-Portfolio/frontend">
                            <div className="divTituloCardMateria">
                                <h3 className="tituloCardMateria">Frontend</h3>
                            </div>
                            <img src={HomeHTMLLogo} alt="MateriasFront" className="materiaImg"></img>
                        </Link>
                    </div>

                    <div className="materia">

                        <div className="materiaTopContainer" onClick={this.handleClickNotPrepared}>

                            <div className="divTituloCardMateria">
                                <h3 className="tituloCardMateria">Backend</h3>
                            </div>

                            <div  className="divWarnIcon">
                                <img src={warnIcon} className="imgWarnIcon"/>
                            </div>

                            <div className="inWorking" >
                                <img src={HomeBackLogo} alt="MateriasBack" className="backConstruction"></img>
                            </div>
                        </div>
                    </div>

                    <div className="materia" >

                        <div className="materiaTopContainer underConstructMateria" onClick={this.handleClickUnderConstruction}>

                            <div  className="underConstruction" >

                                <div className="stopIcon"> 
                                    <img src={stopIcon}  alt="stopIcon" className="stopIconImg"/>
                                </div>

                                <div className="workerIcon">
                                    <img src={workerIcon} alt="workerIcon" className="workerIconImg"/>
                                </div>
                            </div>
                        </div>

                    </div>

                </Carousel>
                
            </div>

        )

        }
}

Materias.propTypes = {
    t: PropTypes.func.isRequired,
};


export default translate(Materias);

